module.exports = __webpack_public_path__ + "img/md-item08.13567fb.png";